@import "../../../globalStyles/commons";

:host {
  display: inline-block;
  transform: scale(0);
  top: 0;
  left: 0;
  position: absolute;
  pointer-events: none;
  transition: transform 0.1s ease-out 0s;

  z-index: v(--z-index-popover);

  /**
   * @prop --popover-content-background: Background color of the popover content
   */
  --popover-content-background: var(--layer);

  /**
   * @prop --popover-padding: Padding of the popover content
   */
  --popover-content-padding: #{v(--spacing-05)};

  /**
   * @prop --popover-content-border-radius: Border radius of the popover content
   */
  --popover-content-border-radius: 2px;

  /**
    * @prop --goat-menu-shadow: Shadow of popover content
   */
  --popover-content-shadow: none;

  --popover-content-caret-size: 0.75rem;
}

:host-context(goat-popover[open]) {
  pointer-events: auto;
  transform: scale(1);
}

:host-context(goat-popover[tip="caret"]) {
  .arrow {
    transform: rotate(45deg) scale(1);
  }
}

.popover-content {
  position: relative;
  background: var(--popover-content-background);
  padding: var(--popover-content-padding);
  border-radius: var(--popover-content-border-radius);
  filter: var(--popover-content-shadow, none);

  .arrow {
    width: var(--popover-content-caret-size);
    height: var(--popover-content-caret-size);
    background: var(--popover-content-background);
    transform: rotate(45deg) scale(0);
    position: absolute;
    z-index: -1;
  }

}

